'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidCheckmarkCircle = function IoAndroidCheckmarkCircle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.1 16.9l5 5 14-13.9 2.3 2.2-16.3 16.3-7.3-7.3z m19.6 3.1h3.3c0 8.9-7.3 16.3-16.2 16.3s-16.3-7.4-16.3-16.3 7.3-16.2 16.3-16.2c2.1 0 4.2 0.4 6 1.2l-2.5 2.5c-1.1-0.3-2.3-0.5-3.5-0.5-7.2 0-13 5.8-13 13s5.8 13 13 13 12.9-5.8 12.9-13z' })
        )
    );
};

exports.default = IoAndroidCheckmarkCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-checkmark-circle.js
// module id = 2319
// module chunks = 168707334958949